<template>
	<div class="alert-container" :style="{ right: right }">
		<v-alert
			v-for="(alert, index) in alerts"
			:key="index"
			border="left"
			:color="alert.color"
			:dismissible="!alert.sticky"
			:icon="alert.icon"
			:type="alert.type"
			:dense="alert.important"
			:prominent="alert.important"

		>
			{{ alert.message }}
			<template #close>
				<v-btn
					class="v-alert__dismissible"
					:color="alert.color"
					:icon="true"
					:small="true"
					:aria-label="$t('close')"
					@click="() => remove(alert)">
					<v-icon color="white">mdi-close-circle</v-icon>
				</v-btn>
			</template>
		</v-alert>
	</div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
	computed: {
		...mapState({
			alerts: s => s.alerts.alerts,
			right: s => s.drawer ? '250px' : '12px',
		}),
	},
	methods: {
		...mapMutations({
			remove: 'alerts/remove',
		}),
	},
};
</script>

<style scoped>
.alert-container {
	z-index: 9999;
	position: fixed;
	top: 2em;
}
</style>
